/**
 * Rate Master v2.0 — lookup dropdowns API client.
 * Backs the Add-record forms' vehicle-type/make/model and part-name
 * cascading dropdowns. Uses the same RATE_MASTER_BASE (and its
 * NEXT_PUBLIC_RATE_MASTER_API_URL override) as v2-api.ts — deliberately
 * NOT the shared NEXT_PUBLIC_API_URL used by lib/api-client.ts.
 */

import { RATE_MASTER_BASE, authHeaders, fetchJson } from './v2-api';

const HTTP_GET = 'GET';

export interface LookupItem {
  id: number | string;
  name: string;
  code: string | null;
}

const LOOKUPS_BASE = `${RATE_MASTER_BASE}/lookups`;

async function getLookup(path: string, params: Record<string, string | number | undefined> = {}): Promise<LookupItem[]> {
  const qs = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) qs.set(key, String(value));
  }
  const url = qs.toString() ? `${LOOKUPS_BASE}/${path}?${qs.toString()}` : `${LOOKUPS_BASE}/${path}`;
  const response = await fetch(url, { method: HTTP_GET, headers: authHeaders() });
  return fetchJson<LookupItem[]>(response);
}

export function getVehicleTypes(): Promise<LookupItem[]> {
  return getLookup('vehicle-types');
}

export function getVehicleMakes(vehicleTypeId: number | null): Promise<LookupItem[]> {
  return getLookup('vehicle-makes', { vehicle_type_id: vehicleTypeId ?? undefined });
}

export function getVehicleModels(vehicleMakeId: number | null): Promise<LookupItem[]> {
  return getLookup('vehicle-models', { vehicle_make_id: vehicleMakeId ?? undefined });
}

export function getVehiclePartNames(vehicleTypeId: number | null): Promise<LookupItem[]> {
  return getLookup('vehicle-part-names', { vehicle_type_id: vehicleTypeId ?? undefined });
}
